import GraphQlProvider from "./ApolloProvider/ApolloProvider";
import { FeatureFlagsProvider } from "./FeatureFlagsProvider";
import { ThemeProvider } from "./ThemeProvider";
import { SentryErrorBoundary } from "../components/SentryErrorBoundary/SentryErrorBoundary";
import {
  Button,
  Divider,
  View,
  withAuthenticator,
} from "@aws-amplify/ui-react";
import assert from "assert";
import { EuiImage } from "@inscopix/ideas-eui";
import Inscopix_logo from "assets/Inscopix-logo.svg";
import { BackendStatusManager } from "./BackendStatusManager/BackendStatusManager";
import { Auth } from "aws-amplify";
import { UserProvider } from "./UserProvider/UserProvider";
import { FileUploadProvider } from "stores/upload/FileUploadProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FlyoutProvider } from "./FlyoutProvider/FlyoutProvider";
import { AppHeaderProvider } from "providers/AppHeaderProvider";
import { TourProvider } from "./TourProvider/TourProvider";

const IDP = process.env.REACT_APP_AWS_AUTH_SSO_IDP;
const IDP_NAME = process.env.REACT_APP_AWS_AUTH_SSO_IDP_NAME ?? "SSO";

const authenticatorComponents = {
  Header() {
    return (
      <View textAlign="center">
        <EuiImage
          size="l"
          alt="Inscopix logo"
          aria-label="Inscopix logo"
          url={Inscopix_logo}
          style={{ padding: "20px" }}
        />
        {IDP !== undefined && (
          <Button
            variation="primary"
            size="large"
            isFullWidth={true}
            onClick={() => void Auth.federatedSignIn({ customProvider: IDP })}
          >
            Sign in with {IDP_NAME}
          </Button>
        )}
        {IDP !== undefined && (
          <div style={{ margin: "30px" }}>
            <Divider label="OR" />
          </div>
        )}
      </View>
    );
  },
};

const authenticatorFormFields = {
  signIn: {
    username: {
      placeholder: "Email",
      isRequired: true,
      labelHidden: true,
    },
    password: {
      placeholder: "Password",
      isRequired: true,
      labelHidden: true,
    },
  },
  resetPassword: {
    username: {
      placeholder: "Enter your email",
      isRequired: true,
      labelHidden: true,
    },
  },
};

const queryClient = new QueryClient();

const GlobalProviders = (props?: { children: React.ReactNode }) => {
  assert(
    props !== undefined,
    "Expected Global Providers to have defined props",
  );

  return (
    <SentryErrorBoundary tag={"providers"}>
      <ThemeProvider>
        <FeatureFlagsProvider>
          <BackendStatusManager>
            <GraphQlProvider>
              <QueryClientProvider client={queryClient}>
                <UserProvider>
                  <FileUploadProvider>
                    <AppHeaderProvider>
                      <FlyoutProvider>
                        <TourProvider>{props.children}</TourProvider>
                      </FlyoutProvider>
                    </AppHeaderProvider>
                  </FileUploadProvider>
                </UserProvider>
              </QueryClientProvider>
            </GraphQlProvider>
          </BackendStatusManager>
        </FeatureFlagsProvider>
      </ThemeProvider>
    </SentryErrorBoundary>
  );
};

export default withAuthenticator(GlobalProviders, {
  components: authenticatorComponents,
  formFields: authenticatorFormFields,
});
